import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { ChannelMessageItem, MediaModel, TypingDataModel, mapToChannelMessage } from '../../models/conversations';
import { UserModel } from '../../models/users.model';
import { UserService } from "../../services/UserService";
import { UtilityService } from '../../services/UtilityService';
import { ChannelConversationService } from '../../services/channels/ChannelConversationService';
import { LiveChatService } from '../../services/channels/LiveChatService';
import { connect, useSelector } from "react-redux";
import * as selector from '../../selectors/selectors';
import { ChannelAccountModel } from '../../models/channels/channels.model';
import { ViewTextLabels, appNote, buttonLabels } from '../shared/constants';
import { BotIsTypingIcon, FalkonAiFilledIcon, NewMessageRecivedIcon, ResubscribeIcon, SuggestedRepliesBoxCancelIcon, TypeIndicatorIcon, UnsubscribeIcon } from '../../icon';
import DisplayConversation from './display-conversation';
import { AppState } from '../../reducers/models';
import { UpdateChannelConversationHistory } from '../../actions';
import VisibilitySensor from 'react-visibility-sensor';
import { ChannelUserService } from '../../services/ChannelUserService';
import AnimateLoaderComponent from '../shared/loaders/animate-loader.component';
import IsUserTypingAnimation from "../shared/loaders/userTyping.json";
import IsOrgUserTypingAnimation from "../shared/loaders/orgUserTyping.json";
import { ChannelAiService } from '../../services/channels/ChannelAiService';
import { ReactTyped } from 'react-typed';

interface IStateProps {
    AllUsers: UserModel[];
    TypingData: TypingDataModel[];
    ShowingAlert: boolean;
    ChannelHistory: { [key: string]: ChannelMessageItem[] };
    IsTeamsApp: boolean;
}
interface IDispatchProps {
    UpdateChannelHistory: (channelAccountId: string, history: ChannelMessageItem[]) => void,
}

interface IProps extends IStateProps, IDispatchProps {
    CardData: any;
    OpenForwardMessage: (media: MediaModel, msg: string) => void;
    UnreadCount: number;
    scrollRef: React.MutableRefObject<any>;
    activeCardIndex: number;
    pathName: string;
    DeviceHeight: number;
    IsMobileDevice: boolean;
    ChannelType?: number;
    handleSendSuggestion?: (message: string) => void;
}


const ConversationHistoryPageNew = (props: IProps) => {
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice)
    const user = ChannelUserService.getCurrentUserFromLocalStorage()
    const Channels: ChannelAccountModel[] = useSelector(selector.Channels)
    const { UnReadCount } = props.CardData
    const [history, setHistory] = useState<any[]>([])
    const inbound = history?.filter(x => !x.IsOutbound)
    const innerRef = useRef<any>();
    const [LoadingHistory, setLoadingHistory] = useState<boolean>(false)
    const [IsBottom, setIsBottom] = useState<boolean>(false)
    const [IsMessageRecived, setIsMessageRecived] = useState<boolean>(false)
    const [PhoneNumberTypingData, setPhoneNumberTypingData] = useState<TypingDataModel[]>(props.TypingData.filter(x => UtilityService.maskPhoneNumberOnLength(x.ReceiverPhoneNumber) === UtilityService.maskPhoneNumberOnLength(props.CardData.PhoneNumber)))
    const [historyApiPageCount, setHistoryApiPageCount] = useState<number>(0)
    const [openSuggestedReplies, setOpenSuggestedReplies] = useState<boolean>(false)
    const [suggestedReplies, setSuggestedReplies] = useState<string[]>([])
    const [selectedMessageForSuggestion, setSelectedMessageForSuggestion] = useState<string>("")


    useLayoutEffect(() => {
        setSuggestedReplies([]);
        setOpenSuggestedReplies(false);
        setHistoryApiPageCount(0)
        const History = props.ChannelHistory[props.CardData?.ID]
        if (!History) {
            getHistory()
        }
        else {
            setHistory([...props.ChannelHistory[props.CardData?.ID]]?.sort((a, b) => new Date(a.CreatedAt)?.getTime() - new Date(b.CreatedAt)?.getTime()))
        }
    }, [props.CardData, props.ChannelHistory[props.CardData?.ID]])

    useEffect(() => {
        setTimeout(() => {
            scrollToBottom();
        }, 550);
    }, [props.activeCardIndex])

    const getMessageDateTimeDayWise = (index: number) => {
        const filteredHistory = history?.filter(x => x?.MessageType !== "UPDATE")
        if (!filteredHistory[index].Message) return "";

        let newDate = UtilityService.convertToDateWithWeekFormat(
            filteredHistory[index].MessageDateTime || filteredHistory[index].CreatedAt?.replace(" +0000 UTC", "Z")
        );
        if (index === 0) {
            return newDate
        };
        let prevDate = UtilityService.convertToDateWithWeekFormat(
            filteredHistory[index - 1].MessageDateTime || filteredHistory[index - 1].CreatedAt?.replace(" +0000 UTC", "Z")
        );
        return newDate !== prevDate ? newDate : "";
    }


    const markAsRead = () => {
        ChannelConversationService.readChannelConversation(user.OrganizationID, props.CardData.ID).then(x => {
        }).catch(y => {
        })

        LiveChatService.ReadMessageStatus({ time: new Date().valueOf(), sender: { id: user.ID }, recipient: { id: props.CardData.ID } }).then(x => {
        }).catch(y => {
        })

    }

    const getHistory = () => {
        const { current } = innerRef;
        setLoadingHistory(true);
        const historyData = props.ChannelHistory[props.CardData?.ID] || [];
        const ID = props.CardData.ID;
        ChannelConversationService.getParticipantMessages(ID, Math.ceil((!historyData ? 0 : historyData.length) / 100) + 1).then((res) => {
            if (res.data.length) {
                props.UpdateChannelHistory(ID, [...res.data.map(mapToChannelMessage), ...historyData]);
                if (Math.ceil((historyData.length === 1 ? 0 : historyData.length) / 100) + 1 > 1) {
                    setHistoryApiPageCount(1)

                    const heightBeforeRender = current.scrollHeight;
                    setTimeout(() => {
                        current.scrollTop = current.scrollHeight - heightBeforeRender;
                        setLoadingHistory(false);
                    }, 120);
                }
                else {
                    setLoadingHistory(false);
                }
            }
        }).catch(err => {
            setLoadingHistory(false)
        })
    }

    useLayoutEffect(() => {
        const { current } = innerRef;

        if (!LoadingHistory && historyApiPageCount === 0 && !!current) {
            setTimeout(() => {
                current.scrollTop = current.scrollHeight
            }, 0);
        }

    }, [props.activeCardIndex, props.pathName, innerRef.current, LoadingHistory])

    useEffect(() => {
        const { current } = innerRef;
        setTimeout(() => {
            current.scrollTop = current?.scrollHeight
        }, 10);
    }, [innerRef, history])


    const onScroll = async () => {
        const { current } = innerRef;

        if (!!current) {
            if (!LoadingHistory && current.scrollTop < 20 && history?.length === 100 * (Math.ceil((history?.length === 1 ? 0 : history?.length) / 100))) {

                getHistory()
            }
        }

        const isBottom = Math.abs(current.scrollHeight - current.clientHeight - current.scrollTop) < 1;
        if (isBottom) {

            setIsBottom(true)
            setIsMessageRecived(false)
        }
        else {

            setIsBottom(false)
        }

    };

    const scrollToBottom = () => {
        const { current } = innerRef;
        if (!!current) {
            current.scrollTop = current.scrollHeight
        }
    }

    useEffect(() => {
        setPhoneNumberTypingData(props.TypingData.filter(x => UtilityService.maskPhoneNumberOnLength(x.ReceiverPhoneNumber) === UtilityService.maskPhoneNumberOnLength(props.CardData.PhoneNumber))
        )
    }, [props.TypingData, props.CardData.PhoneNumber])
    const currentUserId = UserService.getCurrentUserId()
    const typingUsers = props.AllUsers?.filter(x => x.ID !== currentUserId && PhoneNumberTypingData?.map(y => y.UserID).includes(x.ID))
    const typingUserNames = typingUsers?.map(x => x.FirstName).join(", ").trim()

    const getConvHistoryHeight = () => {
        if (props.IsMobileDevice) {
            return `${props.DeviceHeight - 255}px`;
        }
        else {
            return `${props.DeviceHeight - (props.ShowingAlert ? 391 : 330)}px`
        }
    }

    const handleReplySuggestions = (message, messageId) => {
        setSelectedMessageForSuggestion(messageId)
        setOpenSuggestedReplies(true)
        // ChannelAiService.getReplySuggestions({ organization_id: ChannelUserService.getCurrentUserFromLocalStorage().OrganizationID, message: message }).then((res) => {
        //     setSuggestedReplies(res.data.suggested_reply);
        // })
    }

    return (
        <>
            <div className='flex-1 o-hidden'>
                <div className={`h-p-100 o-y-auto ${IsMobileDevice ? "" : "px-3"}`} ref={innerRef} onScroll={onScroll}>
                    <div style={{ "height": "50px" }} className={`${!props.IsMobileDevice ? props.ShowingAlert ? props.IsTeamsApp ? "h-v-45" : "h-v-40" : "" : ""}`}>
                        {
                            history?.filter(x => x?.MessageType !== "UPDATE").map((chat, index) => {
                                if (chat?.ConversationID === props.CardData?.ID ) {
                                    return (
                                        <div key={index}>
                                            {
                                                chat?.ID === inbound[inbound?.length - (props.UnreadCount)]?.ID && (props.UnreadCount) > 0 &&
                                                <div className="text-between-line color-con-hist-msg-date h6-semibold color-primary-accent p-1">
                                                    {(props.UnreadCount)} {(props.UnreadCount) ? ViewTextLabels.UNREAD_MESSAGE : ViewTextLabels.UNREAD_MESSAGES}
                                                </div>
                                            }
                                            {
                                                UnReadCount > 0 ?
                                                    index === history.filter(x => x?.MessageType !== "UPDATE").length - UnReadCount &&
                                                    <VisibilitySensor onChange={markAsRead} />
                                                    : null
                                            }

                                            <div className={`color-conv-hist-date-day h6-medium t-align-center ${index === 0 && "mt-1"} `}>
                                                {getMessageDateTimeDayWise(index)}
                                            </div>

                                            {(chat.Message?.toLowerCase() === buttonLabels.STOP.toLowerCase() && !chat.IsOutbound) ?
                                                <div className={'d-flex align-center justify-center h5-regular m-1'}>
                                                    <UnsubscribeIcon className={"mr-1"} />
                                                    <span>{appNote.UNSUBSCRIBE}</span>
                                                </div> :
                                                ((chat.Message?.toLowerCase() === buttonLabels.UNSTOP.toLowerCase() && chat.IsOutbound) || (chat.Message?.toLowerCase() !== buttonLabels.UNSTOP.toLowerCase())) ?
                                                    <DisplayConversation
                                                        MessageData={chat}
                                                        OpenForwardMessage={props.OpenForwardMessage}
                                                        ChannelType={props.ChannelType}
                                                        UserName={props.CardData?.UserName}
                                                        ProfilePicLink={props.CardData?.ProfilePicLink}
                                                        TemplateMessage={chat?.MessagePayload}
                                                        OpenSuggestedReplies={handleReplySuggestions}
                                                        selectedMessageForSuggestion={selectedMessageForSuggestion}
                                                    />
                                                    :
                                                    (chat.Message?.toLowerCase() === buttonLabels.UNSTOP.toLowerCase()) &&
                                                    <div className={'d-flex align-center justify-center h5-regular m-1'}>
                                                        <ResubscribeIcon className={"mr-1"} />
                                                        <span>{appNote.RESUBSCRIBE}</span>
                                                    </div>
                                            }
                                        </div>
                                    )
                                }
                            })
                        }

                        {
                            props.CardData?.UserTyping &&
                            <div className="d-flex pr-2 h-3">
                                <div className={`my-1 h5-regular inboundmsg d-flex justify-flex-end align-center o-hidden w-8 h-5`}>
                                    <AnimateLoaderComponent LoaderAnimation={IsUserTypingAnimation} className={"d-flex justify-center align-center w-p-100 h-p-100"} />
                                </div>
                            </div >
                        }

                        {LoadingHistory &&
                            <div className="p-absolute d-flex w-fill">
                                <span className="mx-auto history-loader"> </span>
                            </div>
                        }

                        {!IsBottom && IsMessageRecived &&
                            <button className='p-sticky d-flex p-1 r-1 b-2 h4-regular float-right' onClick={scrollToBottom}>
                                <NewMessageRecivedIcon />
                            </button>
                        }
                        
                        {typingUserNames &&
                            <div className="d-flex p-sticky b-0 h-3 pl-2">
                                <TypeIndicatorIcon className={"mr-1"} /><span className="color-type-indicator-text h4-regular">{typingUserNames} {typingUsers.length > 1 ? "are" : "is"} typing…</span>
                            </div>
                        }

                        {openSuggestedReplies &&
                            <div className='d-flex p-sticky b-0 bg-color-secondary py-2 mx-2'>
                                <div className='d-flex align-center min-h-4 suggested-reply-box br-5 w-p-100'>
                                    <FalkonAiFilledIcon className='px-1' />

                                    {suggestedReplies.length ?
                                        <div className='flex-1 d-flex flex-wrap align-center o-y-scroll py-1'>
                                            {suggestedReplies.map((suggestion) => {
                                                return (
                                                    <div className='ai-suggested-replies h5-medium p-1 m-1 min-h-2 d-flex align-center br-3 c-pointer' onClick={() => { props.handleSendSuggestion(suggestion); setOpenSuggestedReplies(false); setSuggestedReplies([]); setSelectedMessageForSuggestion(""); }}>
                                                        {suggestion}
                                                    </div>
                                                )
                                            })
                                            }
                                        </div>
                                        :
                                        <div className='flex-1 d-flex flex-wrap align-center o-y-scroll py-2'>
                                            <ReactTyped
                                                strings={[
                                                    "Falkon Ai Generating..."
                                                ]}
                                                typeSpeed={20} // Speed of typing
                                                backSpeed={20} // Speed of backspacing
                                                loop={true} // Disable looping
                                                className='color-ai-primary-btn h5-medium'
                                            />
                                        </div>
                                    }

                                    <SuggestedRepliesBoxCancelIcon className='px-1 c-pointer' onClick={() => { setOpenSuggestedReplies(false); setSelectedMessageForSuggestion(""); setSuggestedReplies([]); }} />
                                </div>
                            </div>
                        }
                    </div >
                </div>
            </div>

            {
                props.CardData?.BusinessTyping && props.CardData?.TypingBy !== ChannelUserService.getCurrentUserFromLocalStorage()?.FullName &&
                <div className='d-flex justify-flex-end mr-3 align-center color-type-indicator-text h5-medium  h-3 o-hidden p-sticky b-0 r-0 ml-auto'>
                    <div className='d-flex justify-center align-center'>
                        <AnimateLoaderComponent LoaderAnimation={IsOrgUserTypingAnimation} className={"d-flex justify-center align-center w-5 h-5 mt-2"} />
                    </div>
                    <div className=''>
                        {props.CardData?.TypingBy === "BOT" ? <BotIsTypingIcon /> : <span> {props.CardData?.TypingBy} is typing</span>
                        }
                    </div>
                </div>
            }
        </>

    )
}

const mapStateToProps = (state: AppState): IStateProps => {
    return {
        AllUsers: state.AllUsers,
        TypingData: state.TypingData,
        ShowingAlert: state.ShowingAlertsCount > 0,
        ChannelHistory: state.ChannelHistory,
        IsTeamsApp: state.IsTeamsApp,
    }
}
const mapDispatchToProps = (dispatch: any): IDispatchProps => {
    return {
        UpdateChannelHistory: (id, history) => UpdateChannelConversationHistory(dispatch, id, history),
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(ConversationHistoryPageNew)

